<template>
  <div class="main">
    <!-- 底部按钮 -->
    <div class="button">
      <div @click="goToArtificial" class="artificial">专人报价</div>
      <div @click="goToAutoPrice" class="automatic">人保报价</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "test",
  methods: {
    goToArtificial() {
      this.$router.push("/car_insurance/artificial");
    },
    goToAutoPrice() {
      window.location ="https://m.piccgd.com/index.html#/index?fromid=209947&vStoreAPP=0&share=1";
    }
  }
};
</script>

<style scoped>
.main {
  background: url("/images/quote/background.png") no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.button{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 8vw;
}

.artificial {
  width: 86.667vw;
  height: 12.533vw;
  background-image: linear-gradient(
      90deg,
      #03e2ea 0%,
      #05e4d2 60%,
      #02f1de 100%
    ),
    linear-gradient(#e4007f, #e4007f);
  background-blend-mode: normal, normal;
  border-radius: 6.267vw;
  color: white;
  text-align: center;
  line-height: 12.533vw;
}
.automatic {
  margin-top: 2.667vw;
  width: 86.667vw;
  height: 12.533vw;
  background-image: linear-gradient(90deg, #37c1ff 0%, #137bfe 100%),
    linear-gradient(#e4007f, #e4007f);
  background-blend-mode: normal, normal;
  border-radius: 6.267vw;
  text-align: center;
  line-height: 12.533vw;
  color: white;
}
</style>
